var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6365 42.6503C16.6982 43.2862 15.6015 43.6485 14.4691 43.6967C13.1502 43.6727 11.889 43.1515 10.9381 42.2373C9.98713 41.323 9.41666 40.0834 9.34082 38.7664L14.6576 35.6084L22.9062 39.3037L17.6365 42.6503Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7759 29.0564L16.8355 27.3219C15.0726 26.5488 13.4135 25.8795 13.4135 23.947C13.3874 23.5705 13.443 23.1928 13.5764 22.8397C13.7098 22.4867 13.9179 22.1666 14.1865 21.9014L22.5105 25.559L20.4648 26.7657C19.8898 27.105 19.5221 27.4161 19.5221 27.8592C19.5221 28.3023 20.0595 28.7359 20.8042 29.0564H20.7759Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6407 10.872L20.5966 13.3324C20.2383 13.5492 19.7481 13.8886 19.7481 14.4353C19.7481 14.9821 20.6908 15.51 21.511 15.9059L16.4676 13.6812C14.9875 13.0213 13.4887 12.286 13.4887 10.4855C13.4785 9.81374 13.6761 9.15528 14.0543 8.60007L24.9895 1.92578C25.7549 2.34659 26.3953 2.96245 26.8456 3.71082C27.296 4.4592 27.5402 5.31345 27.5536 6.18677C27.5602 7.16681 27.2905 8.12885 26.7753 8.96255C26.26 9.79625 25.5202 10.4678 24.6407 10.9002V10.872Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2282 18.7531L32.2289 19.3281L23.8672 15.6422L33.5769 9.78809C34.3446 10.2113 34.9879 10.8283 35.4427 11.5775C35.8976 12.3268 36.1481 13.1822 36.1694 14.0585C36.1849 15.0439 35.9156 16.0129 35.3939 16.849C34.8721 17.6851 34.1201 18.3528 33.2282 18.772V18.7531Z",
    fill: "#96CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1679 25.8608L31.1171 28.029C33.0025 28.8586 33.5398 29.839 33.5398 31.0645C33.5235 31.4273 33.4311 31.7825 33.2688 32.1073C33.1064 32.4321 32.8775 32.7192 32.5971 32.9499L24.292 29.2545L25.6872 28.4815C26.875 27.8122 27.2803 27.4257 27.2803 26.9921C27.2803 26.5584 26.9881 26.2473 26.1774 25.8702L26.1679 25.8608Z",
    fill: "#72A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0007 44.0829C32.8012 42.4972 30.4216 41.1777 27.9116 40.1519L15.3361 34.5617C12.1686 33.1477 10.0664 31.2812 10.0664 28.1137C10.0664 24.9463 11.5559 23.5511 13.4884 22.3256L14.186 21.9014C13.9174 22.1666 13.7093 22.4867 13.5759 22.8397C13.4425 23.1928 13.3869 23.5705 13.413 23.947C13.413 25.8795 15.0721 26.5488 16.8349 27.3219L31.4656 33.7699C34.0297 34.8728 36.3487 36.7582 36.3487 39.9445C36.3803 41.4368 35.9051 42.8956 35.0007 44.0829Z",
    fill: "#4C9847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4925 32.3657L32.5498 32.9407C32.8303 32.71 33.0591 32.423 33.2214 32.0982C33.3838 31.7734 33.4762 31.4181 33.4925 31.0553C33.4925 29.8298 32.9175 28.8494 31.0698 28.0199L15.4211 21.1477C12.2536 19.7242 10.2834 17.9236 10.2834 14.775C10.2731 13.4998 10.6153 12.2465 11.2724 11.1536C11.9295 10.0606 12.8759 9.17049 14.0071 8.58154C13.6289 9.13676 13.4313 9.79522 13.4414 10.4669C13.4414 12.2675 14.9403 13.0028 16.4203 13.6627L31.626 20.3746C34.4069 21.6096 36.6506 23.4761 36.6506 26.8321C36.6827 27.9586 36.3997 29.0717 35.8334 30.046C35.2672 31.0203 34.4401 31.8172 33.4454 32.3469L33.4925 32.3657Z",
    fill: "#296085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3758,
    height: 42.1667,
    fill: "white",
    transform: "translate(9.3125 1.9165)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc46);
export default __webpack_public_path__ + "static/media/SC제일-46.a3ebcb04b5beb2f89aa948254a1a8b3f.svg";
export { ForwardRef as ReactComponent };